'use client'
import moment from "moment";
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import React, {useEffect, useState} from 'react';

import {addDays, format} from "date-fns";
import {useSearchParams} from "react-router-dom";

const dateFormatter = date => {
    // return moment(date).unix();
    return moment(date).format('DD-MM-YYYY');
};


const processData2=(data)=>{

    data.series.forEach((serie)=>{
        let date = new Date(serie.RERR_DATUM)
        serie.date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    })

    data.series.forEach((serie)=>{
        delete serie['OK_datum'];
        serie.date = serie.date.getTime()
    })

    return data
}


const Iop = () => {
    let [graphData, setGraphData] = useState([])
    const [searchParams, setSearchParams] = useSearchParams();
    let host = searchParams.get('host');
    const practitioner_id = searchParams.get('practitioner_id');
    const patient_id = searchParams.get('patient_id');
    const observation_id = searchParams.get('observation_id');
    const service = searchParams.get('service');
    const [width, setWidth]   = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);
    const [ok_datum, setOk_datum] = "09-01-2023"
    const updateDimensions = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }
    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);

    //console.log({host})
    let errorMessage = "";
    if(host === null){
        errorMessage+="<b>Host</b> parameter ontbreekt\n";
    }
    if(practitioner_id === null){
        errorMessage+="practitioner_id parameter ontbreekt\n";
    }
    if(patient_id === null){
        errorMessage+="patient_id parameter ontbreekt\n";
    }
    if(observation_id === null){
        errorMessage+="observation_id parameter ontbreekt\n";
    }
    if(service === null){
        errorMessage+="service parameter ontbreekt";
    }

    let port = "18088"
    //host = "10.249.13.81"
    if (host.toLowerCase() === "tim-tf-pro-03.hosted.local") {
        port = "80";
    }

    // host = host + ":" + port

    // http://localhost:8080/charts/bmi-twl?endpoint=localhost:8080&token=956c00274abcd009c4211bc49883e6e2023ac0d0&code=07vQl4&practitioner_id=100001REPE000001501&patient_id=aaadapRECT002240295&observation_id=aaadgzRERB000474697
    // let url = 'http://' + host + '/charts/bmi-twl?' + 'practitioner_id=' + practitioner_id + '&patient_id=' +  patient_id + '&observation_id=' + observation_id;


    useEffect(() => {
        if(errorMessage==="") {
            let url = `https://${host}/charts/api?practitioner_id=${practitioner_id}&patient_id=${patient_id}&observation_id=${observation_id}&service=${service}`;
            //console.log({url})
            fetch(url)
                .then(response => response.json())
                .then(data => setGraphData(processData2(data)))
        }

    },[host, practitioner_id, patient_id, observation_id])

    console.log({graphData})



    if(host===null || practitioner_id===null || patient_id===null || observation_id===null || service===null){

        return (
            <div style={{"padding": "10px"}}>
                {(host===null) && <p><b>host</b> parameter ontbreekt</p>}
                {(practitioner_id===null) && <p><b>practitioner_id</b> parameter ontbreekt</p>}
                {(patient_id===null) && <p><b>patient_id</b> parameter ontbreekt</p>}
                {(observation_id===null) && <p><b>observation_id</b> parameter ontbreekt</p>}
                {(service===null) && <p><b>service</b> parameter ontbreekt</p>}
            </div>
        )
    }

    let error = graphData.error
    if(error!==undefined){
        return (
            <div style={{"padding": "10px"}}>
                <p>{graphData.error}</p>
            </div>
        )
    }

    if(graphData.series===undefined){
        return (
            <div style={{"padding": "10px"}}>
                <p>{graphData}</p>
            </div>
        )
    }


    return (
        <ResponsiveContainer width={width-40} height={height-40} style={{"padding": "10px"}}>

            <BarChart
                width={500}
                height={300}
                data={graphData.series}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" interval="preserveStartEnd" tickFormatter={dateFormatter}/>
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="OD" fill="#8884d8"  />
                <Bar dataKey="OS" fill="#7C345D" />

            </BarChart>
        </ResponsiveContainer>
    );
};

export default Iop;
